import { NgModule } from '@angular/core';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';

import {
  faAngleLeft as fasAngleLeft,
  faBan as fasBan,
  faBars as fasBars,
  faBell as fasBell,
  faCalendarAlt as fasCalendarAlt,
  faCaretDown as fasCaretDown,
  faCaretUp as fasCaretUp,
  faCheck as fasCheck,
  faCheckCircle as fasCheckCircle,
  faChevronRight as fasChevronRight,
  faCopy as fasCopy,
  faCrown as fasCrown,
  faExclamationCircle as fasExclamationCircle,
  faExternalLinkAlt as fasExternalLinkAlt,
  faEyeSlash as fasEyeSlash,
  faFileImage as fasFileImage,
  faMoneyBillWave as fasMoneyBillWave,
  faHashtag as fasHashtag,
  faHourglassHalf as fasHourglassHalf,
  faLock as fasLock,
  faMapMarkedAlt as fasMapMarkedAlt,
  faMapSigns as fasMapSigns,
  faPaw as fasPaw,
  faPencilAlt as fasPencilAlt,
  faPhone as fasPhone,
  faPoundSign as fasPoundSign,
  faQuestionCircle as fasQuestionCircle,
  faSpinner as fasSpinner,
  faTimes as fasTimes,
  faTrashAlt as fasTrashAlt,
  faUser as fasUser,
  faMinusCircle as fasMinusCircle,
  faTimesCircle as fasTimesCircle,
  faInfoCircle as fasInfoCircle
} from '@fortawesome/free-solid-svg-icons';

import {
  faCheckSquare as farCheckSquare,
  faCircle as farCircle,
  faClock as farClock,
  faSquare as farSquare,
  faTimesCircle as farTimesCircle,
} from '@fortawesome/free-regular-svg-icons';

import {
  faFacebookF as fabFacebookF,
  faInstagram as fabInstagram,
  faTwitter as fabTwitter,
  faWhatsapp as fabWhatsapp,
} from '@fortawesome/free-brands-svg-icons';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    FontAwesomeModule,
  ],
})

export class IconsModule {
  constructor(private library: FaIconLibrary) {
    library.addIcons(
      fasAngleLeft,
      fasBan,
      fasBars,
      fasBell,
      fasCalendarAlt,
      fasCaretDown,
      fasCaretUp,
      fasCheck,
      fasCheckCircle,
      farCircle,
      farClock,
      fasCrown,
      fasCopy,
      fasChevronRight,
      fasExclamationCircle,
      fasExternalLinkAlt,
      fasEyeSlash,
      fasHashtag,
      fasHourglassHalf,
      fabFacebookF,
      fasFileImage,
      fabInstagram,
      fasLock,
      fasMapMarkedAlt,
      fasMapSigns,
      fasMoneyBillWave,
      fasPaw,
      fasPencilAlt,
      fasPhone,
      fasPoundSign,
      fasQuestionCircle,
      fasSpinner,
      fasTimes,
      farTimesCircle,
      fasTrashAlt,
      fabTwitter,
      fasUser,
      farSquare,
      fabWhatsapp,
      farCheckSquare,
      fasMinusCircle,
      fasTimesCircle,
      fasInfoCircle
    );
  }
}
